import * as ActionTypes from '../actionTypes';

export const initialState = {
    eSESSION: {},
    COUNTRY_CODE: 'en',
    UUID: null,
    ADMIN_TYPE: null,
}
/*
*/
export const eSESSION_reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.eSESSION:
            return Object.assign({}, state, { eSESSION: action.eSESSION });
        case ActionTypes.COUNTRY_CODE:
            return Object.assign({}, state, { COUNTRY_CODE: action.COUNTRY_CODE });
        case ActionTypes.UUID:
            return Object.assign({}, state, { UUID: action.UUID });
        case ActionTypes.ADMIN_TYPE:
            return Object.assign({}, state, { ADMIN_TYPE: action.ADMIN_TYPE });
        default:
            return state;
    }
}


